import {Global} from "./styles/global";
import {MyThemeProvider} from "./contexts/ThemeContext";
import styled from "styled-components";
import Header from "./components/Header/Header";
import Flex from "./components/UI/Flex";
import Menu from "./components/Menu/Menu";
import {MenuContextProvider} from "./contexts/MenuContext";

const AppWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
`

const StyledAppMain = styled(Flex)`
  position: relative;
  width: 100%;
`

function App() {
  return (
    <MyThemeProvider>
      <Global />
      <AppWrapper className={"app-layout"}>
        <Flex direction={"row"}>
          <MenuContextProvider>
            <Menu />
          </MenuContextProvider>
          <StyledAppMain direction={"column"}>
            <Header />
            <Flex direction={"column"}>

            </Flex>
          </StyledAppMain>
        </Flex>
      </AppWrapper>
    </MyThemeProvider>
  );
}

export default App;
